import { render, staticRenderFns } from "./CheckLinkFieldsModal.vue?vue&type=template&id=89a6fa10"
import script from "./CheckLinkFieldsModal.vue?vue&type=script&lang=js"
export * from "./CheckLinkFieldsModal.vue?vue&type=script&lang=js"
import style0 from "./CheckLinkFieldsModal.vue?vue&type=style&index=0&id=89a6fa10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports